import { theme as antdTheme, type ThemeConfig } from 'antd';

/**
 * Captive-portal theme. Reuses the admin SPA's dark + compact token set
 * (apps/admin/src/theme/theme.ts, per docs/ui/design-guidelines.md) so the
 * subscriber portal reads as the same product: near-black surfaces, a single
 * centered card, blue primary, red reserved for destructive actions. Colors live
 * in tokens (never hardcoded in components).
 */
export const colors = {
  bgLayout: '#1a1d21',
  bgContainer: '#22262b',
  bgElevated: '#282d33',
  bgField: '#15181c',
  border: '#31363c',
  borderSubtle: '#282c31',
  primary: '#3b82f6',
  danger: '#e5484d',
  success: '#3fb950',
  warning: '#d9a441',
  textMuted: '#8b939c',
} as const;

export const themeConfig: ThemeConfig = {
  algorithm: [antdTheme.darkAlgorithm, antdTheme.compactAlgorithm],
  cssVar: true,
  token: {
    colorPrimary: colors.primary,
    colorInfo: colors.primary,
    colorError: colors.danger,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorBgLayout: colors.bgLayout,
    colorBgContainer: colors.bgContainer,
    colorBgElevated: colors.bgElevated,
    colorBorder: colors.border,
    colorBorderSecondary: colors.borderSubtle,
    borderRadius: 7,
    fontSize: 14,
    controlHeight: 34,
    wireframe: false,
  },
  components: {
    Card: { colorBgContainer: colors.bgContainer },
    Input: { colorBgContainer: colors.bgField },
    Button: { primaryShadow: 'none', defaultShadow: 'none' },
  },
};
